export class AchievementsApi {
    client;
    constructor(client) {
        this.client = client;
    }
    /**
     * Get all achievement definitions (public).
     */
    async getDefinitions() {
        return this.client.get('/api/achievements/definitions');
    }
    /**
     * Get own achievements (identity session required).
     */
    async getMine() {
        return this.client.get('/api/achievements/me');
    }
    /**
     * Get another identity's achievements (privacy-gated).
     */
    async getForIdentity(identityId) {
        return this.client.get(`/api/identity/${encodeURIComponent(identityId)}/achievements`);
    }
    /**
     * Get holder count for a specific achievement.
     */
    async getStats(achievementId) {
        return this.client.get(`/api/achievements/${encodeURIComponent(achievementId)}/stats`);
    }
    /**
     * Get global holder counts for all achievements.
     */
    async getGlobalStats() {
        return this.client.get('/api/achievements/stats');
    }
    /**
     * Claim a client-triggered achievement action.
     */
    async claim(action) {
        return this.client.post('/api/achievements/claim', { action });
    }
}
//# sourceMappingURL=achievements-api.js.map